export default __webpack_public_path__ + "static/media/trr-food-smallplate-pudding.b0fb9e2e.png";